
<template>
  <!-- accordion like settings-->

  <v-card class="fluid-column ma-5" style="min-height: 50vh">

    <v-card-item>
      <v-card-title class="text-headline-small">2.0.1</v-card-title>
      <v-card-text>
        <p>Interventi principali:</p>
        <ul class="pl-6">
          <li>Risolto bug su interpretazione centro mappa lat/lon 4326/3857 durante modifica features</li>
        </ul>
      </v-card-text>      
      <v-card-title class="text-headline-small">2.0.0</v-card-title>
      <v-card-text>
        <p>Con questo rilascio migliorano le prestazioni e la stabilità.</p>
        <p>Gli interventi principali:</p>
        <ul class="pl-6">
          <li>upgrade versioni pacchetti Node</li>
          <li>tecnologia per mappe offline: pmtiles prende il posto di mbtiles</li>
          <li>miglioramenti indicizzazione files su IDB</li>
          <li>risoluzione bugs:
            <ul>
              <li>drag+click su input number</li>
              <li>correzione larghezza cards</li>
            </ul>
          </li>
          <li>visualizzazione etichette a zoom alto</li>
          <li>Rinominata pagina Storage in Sistema, adesso mostra Statistiche sul Sistema (CPU, RAM, Storage)</li>
        </ul>
      </v-card-text>
    </v-card-item>

  </v-card>
</template>

<script setup>

import { useDataStore } from '@/store/data';

const dataStore = useDataStore();

</script>
